import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Address } from '../types/address';
import './CheckoutAddress.css';

interface CheckoutAddressProps {
  selectedAddress: Address | null;
  onAddressChange?: () => void;
}

const CheckoutAddress: React.FC<CheckoutAddressProps> = ({ selectedAddress, onAddressChange }) => {
  const navigate = useNavigate();

  const handleChangeAddress = () => {
    // Navigate to profile page with address tab
    navigate('/profile', { state: { openAddresses: true } });
    if (onAddressChange) onAddressChange();
  };

  if (!selectedAddress) {
    return (
      <div className="checkout-address-section">
        <div className="address-warning">
          <p>⚠️ No delivery address selected</p>
          <button onClick={handleChangeAddress} className="add-address-checkout-btn">
            + Add Delivery Address
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-address-section">
      <div className="delivery-address-card">
        <div className="address-header-checkout">
          <h3>📦 Delivery Address</h3>
          <button onClick={handleChangeAddress} className="change-address-btn">
            Change Address
          </button>
        </div>
        <div className="address-details">
          <p className="address-name">{selectedAddress.fullName}</p>
          <p className="address-line">{selectedAddress.street}</p>
          <p className="address-line">{selectedAddress.city}, {selectedAddress.state}</p>
          {selectedAddress.landmark && (
            <p className="address-landmark-checkout">📍 Landmark: {selectedAddress.landmark}</p>
          )}
          <p className="address-phone-checkout">📞 {selectedAddress.phone}</p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutAddress;